var styleDataHash = "c988a729";
const injectCss = () => {
  var css = `.PrmeA{margin-left:0;margin-right:auto;z-index:1}.PrmeA:not(.l6SHT){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.PrmeA:not(.l6SHT){float:none;margin-right:auto}}}@container (width < 640px){.PrmeA:not(.l6SHT){float:none;margin-right:auto}}._1DbrI{margin-left:auto;margin-right:0;z-index:1}._1DbrI:not(.l6SHT){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){._1DbrI:not(.l6SHT){float:none;margin-left:auto}}}@container (width < 640px){._1DbrI:not(.l6SHT){float:none;margin-left:auto}}.SszJe{clear:both;display:block}.SszJe:not(.x2T19){margin-left:auto;margin-right:auto;max-width:100%}.l6SHT,.x2T19{width:100%}.xXG2l .l6SHT,.xXG2l .x2T19{margin:0 -8px;width:auto}.gm-yI{width:fit-content}.LjcBl{margin-left:auto;margin-right:auto;max-width:100%}.-BGhC{width:min(350px,100%)!important}.xXG2l .-BGhC{width:50%}.r6qh7{margin-left:auto;margin-right:auto}.xXG2l .r6qh7{width:150px}.qDjaG{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_rtlignore_default = {
  "alignLeft": "PrmeA",
  "textWrapNowrap": "l6SHT",
  "alignRight": "_1DbrI",
  "alignCenter": "SszJe",
  "sizeFullWidth": "x2T19",
  "renderedInTable": "xXG2l",
  "sizeOriginal": "gm-yI",
  "sizeContent": "LjcBl",
  "sizeSmall": "-BGhC",
  "sizeSmallCenter": "r6qh7",
  "flex": "qDjaG"
};
export {
  general_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=general.rtlignore-scss.js.map
